
export interface WebClientError {
  code: number;
  message?: string; // Used for debugging and should not be referenced
  error?: Object; // Used for debugging and should not be referenced, may reference some other error object
}

export interface WebClientErrorResponse {
  error: WebClientError; // Local error
}

export interface WebClientSuccessResponse<TOut> {
  response: TOut; // Web Client API response
}

/**
 * Response returned by executing a Web Client API method
 */
export type WebClientResponse<T> = WebClientSuccessResponse<T> | WebClientErrorResponse;

export namespace WebClientResponseHelper {

  export function isErrorResponse<T>(response: WebClientResponse<T>): response is WebClientErrorResponse {
    return !!(<WebClientErrorResponse> response).error;
  }

  export function failErrorResponse<T>(response: WebClientResponse<T>): PromiseLike<WebClientSuccessResponse<T>> {
    return isErrorResponse(response) ? Promise.reject(response) : Promise.resolve(response);
  }
}
